const initialState = {
    input: "",
    category: "",
    author: "",
};

export default initialState;
